export const resources = {
  UtilsServiceJustNow: '',
  FacesCustomizationEnterModelName: '',
  FaceImageTitle: '',
  FacesName: '',
  FacesModelName: '',
  FacesCustomizationExpandMenuTitle: ''
};
